module.exports = __webpack_public_path__ + "static/media/576JamesPBrawleyDrNW_2018-06-12_179.12c1f4a7.jpg";